<section class="page">
  <h1>Nouveau mot de passe</h1>
  <form class="card" (ngSubmit)="submit()">
    <label class="field">
      <span>Nouveau mot de passe</span>
      <input [(ngModel)]="password" type="password" placeholder="••••••••" name="password" />
    </label>
    <label class="field">
      <span>Confirmer le mot de passe</span>
      <input [(ngModel)]="confirmPassword" type="password" placeholder="••••••••" name="confirmPassword" />
    </label>
    <button class="primary" type="submit" [disabled]="isLoading">
      {{ isLoading ? 'Mise à jour...' : 'Mettre à jour' }}
    </button>
    <p class="success" *ngIf="message">
      {{ message }} <a routerLink="/login">Retour à la connexion</a>
    </p>
    <p class="error" *ngIf="errorMessage">{{ errorMessage }}</p>
  </form>
</section>
